import type { ProjectRepository } from '../repository/ProjectRepository';
import type { ProjectImageGetCommand, ProjectImageGetResponse } from '../entity/ProjectTypes';

export class GetProjectImageUseCase {
  constructor(private readonly repository: ProjectRepository) {}

  async execute(command: ProjectImageGetCommand): Promise<ProjectImageGetResponse> {
    return this.repository.getProjectImage(command);
  }
}
